import * as i0 from "@angular/core";
export class InformationStore {
}
InformationStore.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function InformationStore_Factory() { return new InformationStore(); }, token: InformationStore, providedIn: "root" });
export var InformationStoreKeys;
(function (InformationStoreKeys) {
})(InformationStoreKeys || (InformationStoreKeys = {}));
